var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar-logo-container" },
    [
      _c(
        "router-link",
        { staticClass: "sidebar-logo-link", attrs: { to: "/" } },
        [
          _c("img", {
            staticClass: "sidebar-logo",
            attrs: { src: require("@/assets/images/logoxd.jpg") },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }